import {
  Divider,
  GKButton,
  GKClientDataGrid,
  Grid2,
  PlusIcon,
  PopConfirm,
  Show,
  Tab,
  Tabs,
} from "components";
import { useFetchQuery, useMutation } from "hooks/useQueries";
import { useState } from "react";
import { ORDER_MANAGER_MAPPING, REPLY_EMAIL_PORTFOLIO } from "utils/apiRoutes";
import axiosInstance from "utils/axiosInstance";
import { ExecutionSheetColumns } from "utils/columns";
import { refetchQuery } from "utils/helpers";
import useDocumentTitle from "utils/useDocumentTitle";
import BasketTemplate from "./BasketTemplate";
import EmailReply from "./EmailReply";
import ExecutionSheetModal from "./ExecutionSheetModal";

const ExecutionSheet = () => {
  useDocumentTitle("Execution Sheet");

  const [tabIndex, setTabIndex] = useState(0);
  const [showSheetModal, setShowSheetModal] = useState(false);
  const [sheetDetails, setSheetDetails] = useState(null);
  const [deleteId, setDeleteId] = useState();
  const [confirmDelete, setConfirmDelete] = useState<HTMLElement | null>(null);

  const { data: handleReplyTo, isFetching: replyToFetching } = useFetchQuery({
    key: ["GET_REPLAY_EMAIL_LIST"],
    route: REPLY_EMAIL_PORTFOLIO,
  });

  const { data: allSheetData, isLoading } = useFetchQuery({
    key: ["ORDER_MANAGER_MAPPING"],
    route: ORDER_MANAGER_MAPPING,
  });

  const { mutate: handleDeleteExecutionSheet } = useMutation({
    mutationFn: (data) =>
      axiosInstance.delete(`/order-manager-mappings/${data}/`),
    onSuccess: () => {
      refetchQuery("ORDER_MANAGER_MAPPING");
    },
  });

  return (
    <Grid2 container spacing={2}>
      <Grid2 size={12}>
        <Tabs
          onChange={(e, val) => {
            setTabIndex(val);
          }}
          value={tabIndex}
        >
          <Tab label="Order Generation" />
          <Tab label="Order File Format" />
          <Tab label="Pre-Trade Confirmation Email" />
        </Tabs>
        <Divider />
      </Grid2>

      <Grid2 size={12}>
        <Show.When isTrue={tabIndex === 0}>
          <BasketTemplate />
        </Show.When>
        <Show.When isTrue={tabIndex === 1}>
          <GKClientDataGrid
            name="executionSheet"
            maxHeight={"calc(100vh - 410px)"}
            headerComponent={
              <GKButton
                onClick={() => {
                  setSheetDetails({});
                  setShowSheetModal(true);
                }}
                variant="outlined"
                size="medium"
                startIcon={<PlusIcon width={18} />}
              >
                Add Execution Sheet
              </GKButton>
            }
            columns={ExecutionSheetColumns(setConfirmDelete, setDeleteId)}
            loading={isLoading}
            rows={allSheetData?.data || []}
            onRowClick={(params) => {
              setSheetDetails(params.row);
              setShowSheetModal(true);
            }}
          />
        </Show.When>
        <Show.When isTrue={tabIndex === 2}>
          <EmailReply
            data={handleReplyTo?.data?.data}
            isLoading={replyToFetching}
          />
        </Show.When>
      </Grid2>

      {showSheetModal && (
        <ExecutionSheetModal
          open={showSheetModal}
          setOpen={setShowSheetModal}
          sheetDetails={sheetDetails}
        />
      )}

      {confirmDelete && (
        <PopConfirm
          anchorEl={confirmDelete}
          open={Boolean(confirmDelete)}
          setOpen={setConfirmDelete}
          onSuccess={() => handleDeleteExecutionSheet(deleteId)}
        />
      )}
    </Grid2>
  );
};

export default ExecutionSheet;
